// extracted by mini-css-extract-plugin
export default {"fixed":"WFbkQdO0OqYBpTIOyFBN","fluid":"QoaKQxjpWkAmhF_7Cqko","error":"iadmWNH1CkhYEfLhce9O"};